import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './img/logo.png';
import { FaRightFromBracket, } from "react-icons/fa6";
import bhs from './bhs.js';
import bhcalc from './bhcalc.js';

function DashboardHeader() {
  const navigate = useNavigate();
  const selectedLocation = bhs((state) => state.selectedLocation);
  const setSelectedLocation = bhs((state) => state.setSelectedLocation);
  const userSignedOut = bhs((state) => state.userSignedOut);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const { data } = await bhcalc.get('/location');
        setLocations(data);
      } catch (err) {
        console.error('Error fetching locations:', err);
      }
    };
    fetchLocations();
  }, []);

  const handleLocationChange = (e) => {
    setSelectedLocation(e.target.value);
  };

  const handleLogout = () => {
    userSignedOut();
    navigate('/');
  };

  return (
    <div className="flex w-full justify-between content-center">
      <div>
        <img src={logo} alt="logo" className="w-48 pt-2 ml-auto" />
      </div>

      <div className="flex items-center space-x-4 pr-6">
        <label htmlFor="Headline">
            <select
              name="Headline"
              id="Headline"
              value={selectedLocation}
              onChange={handleLocationChange}
              className="mt-0.5 px-4 py-2 w-full rounded border-gray-300 shadow-sm sm:text-sm"
            >
              <option value="">All Locations</option>
              {locations.map((location) => (
                <option key={location.id} value={location.id}>
                  {location.name}
                </option>
              ))}
            </select>
          </label>

        <FaRightFromBracket
          className="text-sky-400 text-xl cursor-pointer"
          onClick={handleLogout}
          title="Logout"
        />
    </div>
    </div>
  );
}

export default DashboardHeader;
